// extracted by mini-css-extract-plugin
export var active = "_2y-2";
export var highlight = "_2y-1";
export var highlightLayer = "_2y-0";
export var issuePopover = "_2y-3";
export var statusIcon = "_2y-4";